/**
 *
 * Vuetify is a Vue UI Library with beautifully handcrafted Material Components.
 * No design skills required — everything you need to create amazing applications is at your fingertips.
 *
 * */

import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify)

const opts = {}

export default new Vuetify(opts)
